import React, { useEffect, useRef, useState } from 'react';
import { PrivacyPolicyForm } from '../../components';
import {
  NavigationParamList,
  ScreenName,
  StackNavigationScreenProps,
} from '../../navigation/types';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import { useMessage } from '../../contexts/Messages/MessageContext';
import { SplashScreen } from '../index';
import client from '../../client/client';

const PrivacyPolicyScreen: React.FC<
  StackNavigationScreenProps<NavigationParamList, ScreenName.PrivacyPolicyScreen>
> = () => {
  const { fetchMe, me } = useAuth();
  const { setMessage } = useMessage();
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Screen can be unmounted by the navigator remount that fires when `me`
  // updates after fetchMe(). Guard async completions so they don't touch
  // freed React state during that teardown.
  const isMountedRef = useRef(true);
  useEffect(
    () => () => {
      isMountedRef.current = false;
    },
    [],
  );

  const handleAccept = async () => {
    setIsSubmitting(true);
    try {
      if (!me?.conditionAccepted) {
        await client.acceptCondition();
      }
      await fetchMe();
    } catch (error) {
      if (isMountedRef.current) {
        setIsSubmitting(false);
        setMessage({ message: error.message, type: 'error' });
      }
    }
  };

  if (isSubmitting) {
    return <SplashScreen />;
  }

  return <PrivacyPolicyForm onAccept={handleAccept} initialChecked={me?.conditionAccepted} />;
};

export default PrivacyPolicyScreen;
